import React from "react";
import ScheduleForm from "./components/ScheduleForm";

const ScheduleView = () => {
  return (
    <div style={{ padding: 24, minHeight: 360, backgroundColor: "#fff" }}>
      <ScheduleForm />
    </div>
  );
};

export default ScheduleView;
